import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@scramble/ui';
import { useModal } from '@/providers/modal';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { CountryVerificationModal } from '@/modals/CountryVerificationModal';
import s from './index.module.scss';

export const VerificationCountrySelectButton = ({ onSuccess }) => {
  const { t } = useTranslation();
  const { openSingleModal } = useModal();

  return (
    <div className={s.wrapper}>
      <Button
        label={t('veriff:start_verification')}
        theme="brand"
        appearance="filled"
        size="lg"
        className={s.button}
        onClick={() => openSingleModal(MODAL_IDS.country_verification)}
      />
      <div className={s.desc}>
        <Trans
          ns="veriff"
          i18nKey="veriff_desc"
          components={{
            Link: <a href="https://www.veriff.com/" target="_blank" referrerPolicy="no-referrer" />,
          }}
        />
      </div>
      <CountryVerificationModal onSuccess={onSuccess} />
    </div>
  );
};